export const workOrderQueryKeys = {
  all: () => "work-order"
};
